import { Switch, withStyles } from '@material-ui/core';
import { JobType } from './job_type';
export const JobTypeMappings = {
    [JobType.idVerification]: 'IDV',
    [JobType.idCrosscheck]: 'CrossCheck',
    [JobType.idAml]: 'AML',
    [JobType.idAamva]: 'AAMVA',
    [JobType.idReverification]: 'Reverification',
    [JobType.privateSSN]: 'SSN',
    [JobType.ecbsvSSN]: 'ECBSV SSN',
    [JobType.dob]: 'DOB',
    [JobType.selfieVerification]: 'Selfie Verification',
    [JobType.tinValidation]: 'TIN Validation'
};
export const mapData = {
    pageSize: 'number',
    page: 'number',
    status: 'string',
    success: 'string',
    accountReviewed: 'string',
    from: 'date',
    to: 'date',
    sortBy: 'string',
    sortOrder: 'string',
    tableView: 'number',
    respIdType: 'string',
    respIdState: 'string',
    ids: 'string',
    respIdCountry: 'string',
    lastName: 'string',
    firstName: 'string',
    is_disabled: 'string',
    includeResults: 'boolean',
    billableType: 'string',
    billable: 'string',
    aamvaSource: 'string',
    type: 'string',
    accountId: 'string',
    aml: 'string',
    email: 'string',
    phone: 'string'
};
export const humanPropertyName = {
    internal_id: 'Internal Id',
    'vouched.first_name': 'First Name',
    'vouched.last_name': 'Last Name',
    'vouched.email': 'Email',
    'vouched.phone': 'Phone'
};
export const toProperty = (hp, item) => {
    const prop = Object.values(humanPropertyName).find((key) => humanPropertyName[key] === hp);
    if (!prop || !item.request.properties) {
        return null;
    }
    const found = item.request.properties.find((p) => p.name === prop);
    return found ? found.value : null;
};
export const toAccount = (job, accounts) => {
    if (!accounts) {
        return null;
    }
    const account = accounts.find((a) => a.sid === job.accountId);
    if (!account) {
        return null;
    }
    return account;
};
export const humanJobType = (job) => {
    if (!(job.request.type in JobTypeMappings)) {
        return '';
    }
    return JobTypeMappings[job.request.type];
};
export const toAccountGroupName = (sid, accountGroups) => {
    if (!accountGroups || !sid) {
        return null;
    }
    const found = accountGroups.find((a) => a.sid === sid);
    return found ? found.name : null;
};
export const StyledSwitch = withStyles({
    switchBase: {
        color: '#635BFF',
        '&$checked': {
            color: '#635BFF'
        },
        '&$checked + $track': {
            backgroundColor: '#635BFF'
        }
    },
    checked: {},
    track: {
        border: `1px solid #7f90a0`,
        backgroundColor: '#ffffff'
    }
})(Switch);
